import { useContext } from 'react';
import { CheckoutContext } from '../providers/CheckoutContextProvider.js';

const useCheckoutContext = () => {
    const state = useContext(CheckoutContext);
    const { isLoading, isPaymentCollapsed, setIsPaymentCollapsed, paymentFrontendErrors, addPaymentFrontendError, updatePreferredPayment, deleteSavedCard, checkoutState, appConfig, } = state;
    const payment = checkoutState?.payment;
    const paymentMessages = checkoutState?.stateMessages?.paymentMessages;
    const paymentState = {
        isPaymentLoading: isLoading,
        paymentMethods: payment?.paymentMethods,
        preferredPayment: payment?.preferredPayment,
        savedCards: payment?.savedCards,
        containerType: 'default',
        sid: '121',
        isPlaceOrderButtonEnabled: true,
        customerType: checkoutState.customer?.customerType,
        autoshipmentReadyForOrder: checkoutState?.autoshipment?.readyForOrder,
        paymentMessages: [
            ...(paymentMessages ? paymentMessages : []),
            ...(paymentFrontendErrors ? paymentFrontendErrors : []),
        ],
        applePayButton: checkoutState.applePayButton,
        paypalButton: checkoutState.paypalButton,
        braintreeButton: checkoutState.braintreeButton,
        currency: checkoutState.currency,
        isPlaceOrderButtonDisabled: checkoutState.isPlaceOrderButtonDisabled,
        customerId: checkoutState.customerId,
        grandTotal: checkoutState.grandTotal,
        addPaymentFrontendError,
        isPaymentCollapsed,
        setIsPaymentCollapsed,
        updatePreferredPayment,
        deleteSavedCard,
    };
    return {
        appConfig,
        paymentState,
    };
};

export { useCheckoutContext as default };
//# sourceMappingURL=useCheckoutContext.js.map
